/* eslint-disable no-irregular-whitespace */
import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1, Button, Label } from '@cian/ui-kit';
import { IconActionRefresh16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';

import img from './assets/pic2.svg';

interface IQualityModalProps {
  isPhone: boolean;
  onClick: () => void;
}

export const QualityModal: React.FC<IQualityModalProps> = ({ isPhone, onClick }) => {
  return (
    <div className={styles['container']}>
      <div>
        <img src={img} alt="" />
      </div>

      <div className={styles['content']}>
        <ArticleHeading1>Качество общения с вами — наш главный приоритет</ArticleHeading1>

        <ArticleParagraph1>
          Мы следим за тем, чтобы с вами работали ответственные и заинтересованные профи, которые быстро отвечают
          на сообщения, не пропадают и держат в курсе о ходе сделки.
        </ArticleParagraph1>
        <ArticleParagraph1>
          Менеджер Циана контролирует, чтобы риелтор регулярно присылал отчёты: что сделали, сколько вариантов нашлось,
          каких договорённостей достигли и что планируется делать дальше.
        </ArticleParagraph1>
        <ArticleParagraph1>
          Если агенты не отвечают или нарушают правила, мы их штрафуем и можем исключить из сервиса.
        </ArticleParagraph1>

        <div className={styles['label']}>
          <Label
            background="surface-positive-default"
            color="text-positive-default"
            icon={<IconActionRefresh16 color="text-positive-default" />}
          >
            Если не сработаетесь — подберём другого
          </Label>
        </div>

        <div className={styles['button']}>
          <Button fullWidth={isPhone} onClick={onClick}>
            Приятно знать
          </Button>
        </div>
      </div>
    </div>
  );
};
